import React from 'react'
import {
  InfoWindow,
  Marker,
} from '@react-google-maps/api'
import { Clusterer } from '@react-google-maps/marker-clusterer'
import {
  isDevice,
} from '../../helpers/CommonMamorioHelper'
import {
  deviceIcon,
  mapPinIcon,
} from '../../icons'

type Position = {
  lat: number
  lng: number
}

export interface MamorioMarkerProps {
  mamorio: IMamorio
  clusterer: Clusterer
  isSelected: boolean
  onMarkerClick: () => void
  onInfoWindowClose?: () => void // オプション: インフォウィンドウを閉じる時のハンドラ
  infoWindowOptions: { pixelOffset: google.maps.Size | undefined }
  recentPosition: (mamorio: IMamorio) => Position | null | undefined
  recentDetectedAt: (mamorio: IMamorio) => string
  showMemo?: boolean // オプション: memoフィールドを表示するかどうか
}

const MamorioMarker: React.FC<MamorioMarkerProps> = ({
  mamorio,
  clusterer,
  isSelected,
  onMarkerClick,
  onInfoWindowClose,
  infoWindowOptions,
  recentPosition,
  recentDetectedAt,
  showMemo = false,
}) => {
  const baseIcon = isDevice(mamorio) ? deviceIcon : mapPinIcon
  const isRental = mamorio.is_rent

  // レンタル中の場合は特別なラベル付きアイコンを使用
  const markerIcon = isRental ? {
    url: `${baseIcon}#rental`,
    scaledSize: new window.google.maps.Size(48, 48),
    labelOrigin: new window.google.maps.Point(24, 40),
    anchor: new window.google.maps.Point(24, 24),
  } : {
    url: baseIcon,
    scaledSize: new window.google.maps.Size(48, 48),
    anchor: new window.google.maps.Point(24, 24),
  }

  return (
    <Marker
      key={`mamorios-map-pin-${mamorio.id}`}
      icon={markerIcon}
      label={isRental ? {
        text: '持出中',
        color: '#ffffff',
        fontSize: '10px',
        fontWeight: 'bold',
        className: 'rental-label',
      } : undefined}
      position={recentPosition(mamorio)!}
      clusterer={clusterer}
      onClick={onMarkerClick}
    >
      {isSelected && (
        <InfoWindow
          position={recentPosition(mamorio)!}
          options={infoWindowOptions}
          onCloseClick={onInfoWindowClose || (() => {})}
        >
          <div>
            <span>{mamorio.name}</span>
            <br />
            {
              showMemo && mamorio.memo && (
                <>
                  <span>{mamorio.memo}</span>
                  <br />
                </>
              )
            }
            <span>{recentDetectedAt(mamorio)}</span>
            <br />
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.google.com/maps/search/?api=1&query=${recentPosition(mamorio)!.lat},${recentPosition(mamorio)!.lng}`}
            >
              <span>Googleマップで見る</span>
            </a>
          </div>
        </InfoWindow>
      )}
    </Marker>
  )
}

export default MamorioMarker
